'use strict';

var $ = require('jquery');

/**
 * Chart Context Menu Directive
 * @constructor
 * @requires ChartDirective
 */
var ChartContextMenuDirective = function ChartContextMenuDirective($document) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/context-menu.html'),
    link: function link(scope, element) {
      var chartElement = element.parent().find('.chart-container');
      if (!chartElement) {
        throw new Error('ChartContextMenuDirective must be placed in ChartDirective');
      }
      scope.triggerContextMenuAction = function (item) {
        scope.$emit(item.event);
        element.hide();
      };
      chartElement.on('contextmenu', function (event) {
        element.css({
          display: 'block',
          left: parseInt(event.originalEvent.clientX) + 5 + $(window).scrollLeft(),
          top: parseInt(event.originalEvent.clientY) + 5 + $(window).scrollTop()
        });
        //prevent default context menu
        return false;
      });
      function hideOnWindowClick(event) {
        if ($(event.target).closest(element).length === 0) {
          element.hide();
        }
      }
      $document.on('click', hideOnWindowClick);
      element.on('$destroy', function () {
        $document.off('click', hideOnWindowClick);
      });
    }
  };
};
ChartContextMenuDirective.$inject = ['$document'];
module.exports = ChartContextMenuDirective;